export default __webpack_public_path__ + "static/media/game-loader.fed0143a.gif";